export default function addMinutesToDate(date, minutes, formatted) {
  if (minutes === void 0) {
    minutes = 0;
  }
  if (formatted === void 0) {
    formatted = true;
  }
  const newDate = new Date(date); // Create a copy to avoid modifying the original date
  newDate.setMinutes(newDate.getMinutes() + minutes);
  if (formatted) {
    const year = newDate.getFullYear();
    const month = (newDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = newDate.getDate().toString().padStart(2, '0');
    const hour = newDate.getHours().toString().padStart(2, '0');
    const minute = newDate.getMinutes().toString().padStart(2, '0');
    return year + "-" + month + "-" + day + " " + hour + ":" + minute;
  } else {
    return newDate;
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/addMinutesToDate', addMinutesToDate);